"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicalRecord = void 0;
class MedicalRecord {
    constructor(props) {
        this.affiliateNumber = props?.affiliateNumber || "";
        this.affiliateType = props?.affiliateType || "";
        this.assignation_id = props?.assignation_id || "";
        this.att_category = props?.att_category;
        this.especialidad = props?.especialidad || "";
        this.incidente_id = props?.incidente_id;
        this.mr_preds = {
            abort_description: props?.mr_preds?.abort_description || null,
            destino_final: props?.mr_preds?.destino_final || "",
            diagnostico: props?.mr_preds?.diagnostico || "",
            epicrisis: props?.mr_preds?.epicrisis || "",
            gduh: props?.mr_preds?.gduh || null,
            motivos_de_consulta: props?.mr_preds?.motivos_de_consulta || "",
            observaciones: props?.mr_preds?.observaciones || null,
            pre_clasif: props?.mr_preds?.pre_clasif || "",
        };
        this.mr = {
            alertas: props?.mr?.alertas || null,
            destino_final: props?.mr?.destino_final || null,
            diagnostico: props?.mr?.diagnostico || "",
            dt_cierre: props?.mr?.dt_cierre || null,
            dt: props?.mr?.dt || null,
            epicrisis: props?.mr?.epicrisis || "",
            motivos_de_consulta: props?.mr?.motivos_de_consulta || "",
            observaciones: props?.mr?.observaciones || null,
            ordenes: props?.mr?.ordenes || [],
            prescriptions: props?.mr?.prescriptions || [],
            specialist_referral: props?.mr?.specialist_referral || null,
            receta_ref: props?.mr?.receta_ref || null,
            receta: props?.mr?.receta || [],
            reposo: props?.mr?.reposo || null,
            tratamiento: props?.mr?.tratamiento || null,
        };
        this.patient =
            {
                address: props?.patient?.address || "",
                antecedentes: props?.patient?.antecedentes || "",
                country: props?.patient?.country || null,
                dependant_uid: props?.patient?.dependant_uid || "",
                dni: props?.patient?.dni || "",
                dob: props?.patient?.dob || "",
                fullname: props?.patient?.fullname || "",
                n_afiliado: props?.patient?.n_afiliado || "",
                obra_social: props?.patient?.obra_social || "SIN OBRA SOCIAL(UMA)",
                sex: props?.patient?.sex || "",
                uid: props?.patient?.uid || "",
                ws: props?.patient?.ws || "",
            } || {};
        this.provider =
            {
                cuit: props?.provider?.cuit,
                especialidad: props?.provider?.especialidad,
                fullname: props?.provider?.fullname,
                uid: props?.provider?.uid,
                ws: props?.provider?.ws,
            } || {};
        this.payment_data = {
            currency: props?.payment_data.currency || "",
            full_price: props?.payment_data.full_price || 0,
            id: props?.payment_data.id || "",
            method: props?.payment_data.method || "",
            price: props?.payment_data.price || 0,
            trueMethod: props?.payment_data.trueMethod || "",
        };
        this.timestamps = props?.timestamps;
        this.documentReferences = props?.documentReferences || [];
        this.event_type = props?.event_type || null;
    }
}
exports.MedicalRecord = MedicalRecord;
